var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPohLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#6bb344;}.cls-2,.cls-3{fill:#fff;}.cls-3{fill-rule:evenodd;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 50,
    cy: 50,
    r: 45
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M50,5A45,45,0,1,1,5,50,45.05,45.05,0,0,1,50,5m0-5a50,50,0,1,0,50,50A50,50,0,0,0,50,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M78.49,36.62l-2.86-4.95a1.42,1.42,0,0,0-1.95-.52l-2.63,1.52A27.13,27.13,0,0,0,54.29,23V20a1.43,1.43,0,0,0-1.43-1.43H47.14A1.43,1.43,0,0,0,45.71,20V23A27.13,27.13,0,0,0,29,32.67l-2.63-1.52a1.42,1.42,0,0,0-1.95.52l-2.86,4.95a1.42,1.42,0,0,0,.52,2l2.64,1.53a27.14,27.14,0,1,0,50.66,0L78,38.57A1.42,1.42,0,0,0,78.49,36.62ZM50,71.2A21.43,21.43,0,1,1,71.43,49.77,21.45,21.45,0,0,1,50,71.2ZM37.14,53.89l-5.67-3.27c0-.28,0-.56,0-.85A18.52,18.52,0,0,1,37.14,36.4Zm10,9.08-5.68,3.28a18.65,18.65,0,0,1-9.47-12Zm8-31L40,40.7V34.15A18.33,18.33,0,0,1,55.16,32ZM68,45.32,52.86,36.57l5.68-3.27A18.61,18.61,0,0,1,68,45.32ZM44.84,67.6,60,58.84V65.4a18.5,18.5,0,0,1-10,2.94A18.71,18.71,0,0,1,44.84,67.6Zm18-21.95,5.67,3.27c0,.29,0,.57,0,.85a18.52,18.52,0,0,1-5.71,13.37Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPohLogo);
export default __webpack_public_path__ + "static/media/POH-logo.32b064de2c0cc72e65f89c3bc78d8997.svg";
export { ForwardRef as ReactComponent };